import { Box } from "@mui/material";
import { HOURS_PER_DAY } from "../../utils/dayHourGrid";

type Props = {
	nowHour: number | null;
	hoveredHour: number | null;
};

export const HourCrosshair = ({ nowHour, hoveredHour }: Props) => (
	<Box
		sx={{
			position: "absolute",
			inset: 0,
			display: "grid",
			gridTemplateColumns: `repeat(${HOURS_PER_DAY}, 1fr)`,
			pointerEvents: "none",
		}}
	>
		{Array.from({ length: HOURS_PER_DAY }, (_, h) => (
			<Box
				key={h}
				sx={{
					...(nowHour === h && {
						backgroundColor: "#1565C014",
					}),
					...(hoveredHour === h && { backgroundColor: "#EDEDED" }),
				}}
			/>
		))}
	</Box>
);
